<template>
  <div class="mb-4">
    <div class="border">
      <h4>{{ "upload_document" | setText("Загрузить документы") }}</h4>
      <div v-if="showData">
        <div class="row">
          <div class="col-12 col-md-6" v-for="(t, k) in types" :key="k">
            <div v-if="t.type === 'all' || t.type === data['dealer_type']">
              <h5>{{ t.title }}</h5>
              <zip-upload
                v-model="localData[t.key]"
                :title="'Выберите документ'"
              />
              <a
                v-if="data[t.key]"
                class="btn btn-sm mb-3"
                target="_blank"
                :href="`${data[t.key]}`"
                >{{ "download" | setText("Скачать") }}</a
              >
            </div>
          </div>
        </div>
        <div>
          <button class="btn btn-info btn-warning" @click="uploadRequest">
            {{ "upload_document" | setText("Загрузить документы") }}
          </button>
          <button @click="showData = false" class="btn float-right">
            {{ "hide" | setText("Скрыть") }}
          </button>
        </div>
      </div>

      <div v-else>
        <button @click="showData = true" class="btn btn-success">
          {{ "edit_document" | setText("Редактировать документы") }}
        </button>
      </div>
    </div>

    <div class="mt-5">
      <button class="btn btn-info btn-success mr-2" @click="sendRequest">
        {{ "refresh" | setText("Обновить") }}
      </button>
      <button class="btn" @click="underwriterRequest">U</button>

      <button
        class="btn btn-info btn-danger float-right"
        @click="cancelRequest"
      >
        {{ "cancel" | setText("Отмена") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "@/plugins/functions";

export default {
  methods: {
    async sendRequest() {
      this.$loading(true);

      const action = `applications/${this.data.exchange_id}/status`;
      const url = this.data.bank.api_endpoint_url + action;
      const token = this.data.bank.api_token;
      const auth_type = this.data.bank.api_auth_type;
      const method = "get";

      // const data = this.data.form_data;

      logger(this.$http, {
        name: "Проверить запрос в банк",
        url: url,
        method: method,
        // req: JSON.stringify(data),
      });

      return this.$http({
        method: method,
        // data: toFormData(data),
        url: url,
        headers: {
          // "Content-Type": `multipart/form-data`,
          Authorization: `${auth_type} ${token}`,
          "api-version": `1`,
          platform: `web`,
          language: `ru`,
          Accept: `application/json`,
        },
      })
        .then((response) => {
          const data = response.data;

          if (data && data.data && data.success === true) {
            //init state
            let state = "sent";

            if (
              data.data.status === "pre_scoring_ok" ||
              data.data.status === "underwriter" ||
              data.data.status === "loan_officer" ||
              data.data.status === "loan" ||
              data.data.status === "underwriter_ok" ||
              data.data.status === "problem" ||
              data.data.status === "insurance" ||
              data.data.status === "underwriter_nok"
            ) {
              state = "approve";
            } else if (data.data.status === "pre_scoring_nok") {
              state = "reject";
            } else if (data.data.status === "completed") {
              state = "done";
            } else if (data.data.status === "cancelled") {
              state = "cancel";
            }
            //end init state

            this.$emit("input", {
              status: JSON.stringify(response.data),
              state: state,
            });
          } else if (!data.success) {
            alert("Неизвестная ошибка");
            this.$loading(false);
          }
          //отправка нового статуса

          return response.data;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },

    async uploadRequest() {
      if (!this.localData.loan_certificate || !this.localData.loan_passport) {
        alert("Прикрепите документы");
        return false;
      }

      this.$loading(true);

      const action = `applications/${this.data.exchange_id}`;
      const url = this.data.bank.api_endpoint_url + action;
      const token = this.data.bank.api_token;
      const auth_type = this.data.bank.api_auth_type;
      const method = "post";
      let data = this.data.form_data;

      data["_method"] = "PUT";

      let files = [];

      for (let i = 0; i < this.types.length; i++) {
        if (this.localData[this.types[i].key]) {
          let dkey = this.types[i].key;
          files.push({
            file: this.localData[this.types[i].key],
            document_type: dkey.slice(5),
          });
        }
      }

      data["files"] = await files;

      logger(this.$http, {
        name: "Загрузка документов в банк",
        url: url,
        method: method,
        req: JSON.stringify(data),
      });

      return this.$http({
        method: method,
        data: toFormData(data),
        url: url,
        headers: {
          "Content-Type": `multipart/form-data`,
          Authorization: `${auth_type} ${token}`,
          "api-version": `1`,
          platform: `web`,
          language: `ru`,
          Accept: `application/json`,
        },
      })
        .then((response) => {
          const data = response.data;
          if (data && data.data && data.success === true) {
            let state = "approve";

            if (
              data.data.status === "pre_scoring_ok" ||
              data.data.status === "underwriter" ||
              data.data.status === "loan_officer" ||
              data.data.status === "loan" ||
              data.data.status === "underwriter_ok" ||
              data.data.status === "problem" ||
              data.data.status === "insurance" ||
              data.data.status === "underwriter_nok"
            ) {
              state = "approve";
            } else if (data.data.status === "pre_scoring_nok") {
              state = "reject";
            } else if (data.data.status === "completed") {
              state = "done";
            } else if (data.data.status === "cancelled") {
              state = "cancel";
            }

            this.$emit("input", {
              status: JSON.stringify(response.data),
              exchange_id: data.data.id,
              state: state,
              loan_certificate: this.localData.loan_passport,
              loan_passport: this.localData.loan_passport,
              loan_certificate: this.localData.loan_passport,
              loan_charter: this.localData.loan_charter,
              loan_agreement_founders: this.localData.loan_agreement_founders,
              loan_order_director: this.localData.loan_order_director,
              loan_passport_founders: this.localData.loan_passport_founders,
              loan_form_1: this.localData.loan_form_1,
              loan_form_2: this.localData.loan_form_2,
            });

            setTimeout(() => {
              this.underwriterRequest();
            }, 100);
          } else if (!data.success) {
            alert("Неизвестная ошибка");
            this.$loading(false);
          }
          //отправка нового статуса

          return response.data;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },

    async underwriterRequest() {
      this.$loading(true);

      const action = `applications/${this.data.exchange_id}/underwriter`;
      const url = this.data.bank.api_endpoint_url + action;
      const token = this.data.bank.api_token;
      const auth_type = this.data.bank.api_auth_type;
      const method = "patch";
      // const data = this.data.form_data;

      logger(this.$http, {
        name: "Подтверждение  запроса в банк",
        url: url,
        method: method,
      });

      return this.$http({
        method: method,
        // data: toFormData(data),
        url: url,
        headers: {
          // "Content-Type": `multipart/form-data`,
          Authorization: `${auth_type} ${token}`,
          "api-version": `1`,
          platform: `web`,
          language: `ru`,
          Accept: `application/json`,
        },
      })
        .then((response) => {
          const data = response.data;
          if (data && data.data && data.success === true) {
            let state = "approve";

            if (
              data.data.status === "pre_scoring_ok" ||
              data.data.status === "underwriter" ||
              data.data.status === "loan_officer" ||
              data.data.status === "loan" ||
              data.data.status === "underwriter_ok" ||
              data.data.status === "problem" ||
              data.data.status === "insurance" ||
              data.data.status === "underwriter_nok"
            ) {
              state = "approve";
            } else if (data.data.status === "pre_scoring_nok") {
              state = "reject";
            } else if (data.data.status === "completed") {
              state = "done";
            } else if (data.data.status === "cancelled") {
              state = "cancel";
            }

            this.$emit("input", {
              status: JSON.stringify(response.data),
              state: state,
              is_confirmed: 1,
            });
          } else if (!data.success) {
            alert("Неизвестная ошибка");
            this.$loading(false);
          }

          this.showData = false;
          return response.data;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },

    async cancelRequest() {
      this.$loading(true);

      const action = `applications/${this.data.exchange_id}/cancel`;
      const url = this.data.bank.api_endpoint_url + action;
      const token = this.data.bank.api_token;
      const auth_type = this.data.bank.api_auth_type;
      const method = "patch";
      // const data = this.data.form_data;

      logger(this.$http, {
        name: "Отмена заявки - запрос в банк",
        url: url,
        method: method,
      });

      return this.$http({
        method: method,
        // data: toFormData(data),
        url: url,
        headers: {
          // "Content-Type": `multipart/form-data`,
          Authorization: `${auth_type} ${token}`,
          "api-version": `1`,
          platform: `web`,
          language: `ru`,
          Accept: `application/json`,
        },
      })
        .then((response) => {
          const data = response.data;
          if (data && data.data && data.success === true) {
            let state = "sent";

            if (data.data.status === "cancelled") {
              state = "cancel";
            }

            this.$emit("input", {
              status: JSON.stringify(response.data),
              state: state,
            });
          } else if (!data.success) {
            alert("Неизвестная ошибка");
            this.$loading(false);
          }

          return response.data;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },
  },
  data: () => ({
    types: [
      {
        key: "loan_certificate",
        title: "Свидетельство о регистрации",
        type: "all",
      },
      {
        key: "loan_passport",
        title: "Паспорт / ID карта директора",
        type: "all",
      },
      {
        key: "loan_charter",
        title: "Устав компании",
        type: "llc",
      },
      {
        key: "loan_agreement_founders",
        title: "Учредительный договор",
        type: "llc",
      },
      {
        key: "loan_order_director",
        title: "Приказ о назначении директора",
        type: "llc",
      },
      {
        key: "loan_passport_founders",
        title: "Паспорта / ID карты учредителей",
        type: "llc",
      },
      {
        key: "loan_form_1",
        title: "Бухгалтерский баланс (форма №1)",
        type: "llc",
      },
      {
        key: "loan_form_2",
        title: "Финансовые результаты (форма №2)",
        type: "llc",
      },
    ],

    localData: {
      loan_passport: null,
      loan_certificate: null,
      loan_charter: null,
      loan_agreement_founders: null,
      loan_order_director: null,
      loan_passport_founders: null,
      loan_form_1: null,
      loan_form_2: null,
    },
    showData: false,
  }),
  props: ["value", "data"],
};
</script>
<style>
</style>

   
 